import React from 'react';
import PropTypes from 'prop-types';
import identity from 'lodash/identity';
import { push } from 'connected-react-router';
import { connect, useDispatch } from 'react-redux';

import Modal from 'react/components/Modal';
import { actionCreators } from 'react/api/actions/wizard';
import { getResourceTo } from 'react/utils/utils';

const CancelModal = ({
  entity,
  modalIsOpen,
  toggleCancelModalAction
}) => {
  const dispatch = useDispatch();
  const modalTitle = getResourceTo('cancelModal.label.title');
  const modalParagraph = getResourceTo('cancelModal.label.paragraph');
  const closeButtonLabel = getResourceTo('samlConfiguration.button.close');
  const cancelButtonLabel = getResourceTo('samlConfiguration.button.cancelAndDiscard');

  const goToGrid = () => {
    toggleCancelModalAction({ entity });

    dispatch(push(`/${entity}`));
  };

  const closeModal = () => {
    toggleCancelModalAction({
      entity
    });
  };

  const Footer = () => (
    <>
      <input
        type="button"
        value={closeButtonLabel}
        onClick={closeModal}
      />
      <input
        type="button"
        value={cancelButtonLabel}
        className="btn-secondary"
        onClick={goToGrid}
      />
    </>
  );

  return (
    <Modal
      className="cancelModal"
      isOpen={modalIsOpen}
      title={getResourceTo(modalTitle)}
      crossAxisBtn={false}
      footer={<Footer />}
      closeModalFn={identity}
    >
      <p className="cancelModalLabel">{modalParagraph}</p>
    </Modal>
  );
};

CancelModal.propTypes = {
  entity: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  toggleCancelModalAction: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  modalIsOpen: state.wizard.getIn([ownProps.entity, 'cancelModal', 'modalIsOpen'], false)
});

const mapDispatchToProps = {
  toggleCancelModalAction: actionCreators.toggleCancelModal
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(CancelModal));
